import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "directory-card"
}
const _hoisted_2 = { class: "directory-card__image" }
const _hoisted_3 = { class: "directory-card__info" }
const _hoisted_4 = { class: "directory-card__title" }
const _hoisted_5 = { class: "directory-card__role" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "directory-card__image directory-card__image--new" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "directory-card__info" }
const _hoisted_9 = { class: "directory-card__title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProfilePictureComponent = _resolveComponent("ProfilePictureComponent")

  return ($props.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ProfilePictureComponent, {
            user: $props.user,
            size: "lg"
          }, null, 8 /* PROPS */, ["user"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString($props.user.fullName), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_5, _toDisplayString($props.user.user_role || '-'), 1 /* TEXT */),
          (!$props.hideEmail)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: `mailto:${$props.user.email}`,
                class: "directory-card__email"
              }, _toDisplayString($props.user.email), 9 /* TEXT, PROPS */, _hoisted_6))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: "directory-card directory-card--new",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit( 'add-users', $props.userType )))
      }, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h3", _hoisted_9, " Add " + _toDisplayString($props.userType), 1 /* TEXT */)
        ])
      ]))
}